module.exports = __webpack_public_path__ + "img/dots-horizontal.458b7bc0.svg";